import {createSlice} from "@reduxjs/toolkit";
import {setAllocatableLoadInventorySearchPageFilter} from "./actions";
import {AllocatableLoadInventorySearchCriteria} from "@ots-frontend/ots-data";

type AllocatableLoadInventorySearchPageState = {
    filter?: AllocatableLoadInventorySearchCriteria
}

const INITIAL_STATE: Readonly<AllocatableLoadInventorySearchPageState> = {
    filter: undefined,
};

const allocatableLoadInventorySearchPageSlice = createSlice({
    name: "ui/allocatable-load-inventory-search-page",
    initialState: INITIAL_STATE,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            setAllocatableLoadInventorySearchPageFilter,
            (state, {payload}) => {
                state.filter = payload
            }
        );
    }
});

export const allocatableLoadInventorySearchPageReducer = allocatableLoadInventorySearchPageSlice.reducer;
